import { type Address, MarketParams } from '@morpho-org/blue-sdk'
import { safeGetAddress, safeParseNumber } from '@morpho-org/blue-sdk-viem'
import { ZERO_ADDRESS } from '@morpho-org/morpho-ts'

interface MarketParamsInput {
  collateralAsset: { address: Address } | null
  irmAddress: Address
  lltv: string | number
  loanAsset: { address: Address }
  oracle: { address: Address } | null
}

export interface ConverterOptions {
  parseAddress: (value: string) => Address
  parseNumber: (value: number, decimals: number) => bigint
}

/**
 * Converter class for transforming GraphQL API data to Blue SDK types.
 */
export class BlueSdkConverter {
  constructor(protected readonly options: ConverterOptions) {}

  /**
   * Converts API market params to Blue SDK MarketParams instance.
   * @param dto - Market params from API
   * @returns MarketParams instance
   */
  public getMarketParams(dto: MarketParamsInput) {
    return new MarketParams({
      collateralToken: this.options.parseAddress(dto.collateralAsset?.address ?? ZERO_ADDRESS),
      loanToken: this.options.parseAddress(dto.loanAsset.address),
      oracle: this.options.parseAddress(dto.oracle?.address ?? ZERO_ADDRESS),
      irm: this.options.parseAddress(dto.irmAddress),
      lltv: dto.lltv
    })
  }
}

/**
 * Global converter instance for transforming API data to Blue SDK types.
 */
export const converter = new BlueSdkConverter({
  parseAddress: safeGetAddress,
  parseNumber: safeParseNumber
})
